export default {
  path: '/messageCenter',
  name: '',
  component: () => import('@/components/layout/layout.vue'),
  redirect: '/messageCenter/home',
  children: [
    {
      path: 'index',
      name: 'messageCenter_index',
      component: () => import('./index')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/pages/messageCenter/router_messageCenter.js